import { Theme as InsuranceTypeIconTheme } from 'components/base/Icon/InsuranceTypeIcon'

import { TagsHardcodedContent } from './types'


export const tagsHardcodedContent: TagsHardcodedContent = {
  'homeowners-insurance': {
    title:  'Homeowners Insurance',
    icon: InsuranceTypeIconTheme.home,
    link: '/products/homeowners-insurance',
  },
  'auto-insurance': {
    title:  'Auto Insurance',
    icon: InsuranceTypeIconTheme.auto,
    link: '/products/auto-insurance',
  },
  'life-insurance': {
    title:  'Life Insurance',
    icon: InsuranceTypeIconTheme.life,
    link: '/products/life-insurance',
  },
  'health-insurance': {
    title:  'Health Insurance',
    icon: InsuranceTypeIconTheme.health,
    link: '/products/health-insurance',
  },
  'medicare-insurance': {
    title:  'Medicare Insurance',
    icon: InsuranceTypeIconTheme.medicare,
    link: '/products/medicare-insurance',
  },
  'disability-insurance': {
    title:  'Disability Insurance',
    icon: InsuranceTypeIconTheme.disability,
    link: '/products/disability-insurance',
  },
  'business-insurance': {
    title:  'Business Insurance',
    icon: InsuranceTypeIconTheme.business,
    link: '/products/business-insurance',
  },
  'investments-retirement': {
    title:  'Investments & Retirement',
    icon: InsuranceTypeIconTheme.retirement,
    link: '/products/investments-retirement',
  },
}
